import {Form, Input, InputNumber, Modal, Select, Spin, Switch} from "antd"
import React from "react"
import DisplayResult from "../../../util/DisplayResult"
import {useClubChargeContext} from "../store/useClubChargeContext"

export const ClubChargeForm = ({form, isOpen, walletList, levelList, onCancel, onOk}) => {
    const rechargeWalletOptions = walletList.filter(item => (item.id >= 1000)).map((item) => {
        return {
            value: item.id,
            label: item.name,
        }
    })

    const giftWalletOptions = [{
        value: "0",
        label: "无"
    }, ...rechargeWalletOptions]

    const levelOptions = [{
        value: "0",
        label: "无"
    }, ...levelList.map((item) => ({
        value: item.id,
        label: `${item.name}-${item.discount_name}`,
    }))]


    const isShowAllTable = Form.useWatch("isShowAllTable", form)
    const amount = Form.useWatch("amount", form)
    const giftAmount = Form.useWatch("giftAmount", form)

    const state = useClubChargeContext()

    return <Modal open={isOpen} onCancel={onCancel} onOk={onOk}
                  confirmLoading={state.addOrUpdateChargeState.isLoading()}>
        <Form
            form={form}
        >
            <Form.Item hidden={true} name={"id"}></Form.Item>
            <div style={{fontSize: 20, marginBottom: 16}}>
                充值
            </div>
            <Form.Item label={"充值起步价"} name={"amount"}>
                <InputNumber style={{width:200}} placeholder={"请输入起步价"} controls={false} step={"0.01"} stringMode
                             formatter={value => value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                             parser={value => value ? value.replace(/\$\s?|(,*)/g, '') : ''}/>
            </Form.Item>
            <Form.Item label={"充值钱包"} name={"targetWalletId"}>
                <Select options={rechargeWalletOptions} placeholder={"请选择充值钱包"}></Select>
            </Form.Item>
            <div style={{fontSize: 20, marginBottom: 16}}>
                赠送
            </div>
            <Form.Item label={"赠送金额"} name={"giftAmount"}>
                <InputNumber
                    style={{width:200}}
                    placeholder={"请输入赠送金额"}
                    controls={false}
                    step={"0.01"}
                    stringMode
                    formatter={value => value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                    parser={value => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                />
            </Form.Item>
            <Form.Item label={"赠送钱包"} name={"giftWalletId"}>
                <Select options={giftWalletOptions} placeholder={"请选择赠送钱包"}></Select>
            </Form.Item>
            <div style={{fontSize: 20, marginBottom: 16}}>
                等级
            </div>
            <Form.Item label={"获得会员级别"} name={"giftLevelId"}>
                <Select options={levelOptions} placeholder={"请选择获得会员级别"}></Select>
            </Form.Item>
            <div>
                备注:
                {amount !== undefined ? (Number.isInteger(Number(amount)) ? Number(amount) : Number(amount).toFixed(2)) : ''}起步,
                充{amount !== undefined ? (Number.isInteger(Number(amount)) ? Number(amount) : Number(amount).toFixed(2)) : ''}送
                {giftAmount !== undefined ? (Number.isInteger(Number(giftAmount)) ? Number(giftAmount) : Number(giftAmount).toFixed(2)) : ''}
            </div>
            <div>温馨提示: 充值赠送与会员折扣同步执行,或会出现折上折现象,请谨慎考虑设置.</div>
            <Form.Item label={"全场球台显示"} name={"isShowAllTable"} valuePropName={"checked"}>
                <Switch/>
            </Form.Item>
            {!isShowAllTable &&
                <DisplayResult
                    state={state.getChargeTableListState}
                    onLoading={() => (<Spin/>)}
                    onSuccess={(value) => {
                        const tableOptions = state.getTableListState.getSuccessData().map((e) => ({
                            value: e.id,
                            label: e.name
                        }))

                        const tableIds = value ? value.map((item) => (
                            item.tableId
                        )) : []

                        form.setFieldValue("tableIds", tableIds)

                        return <Form.Item label={"可用球台"} name={"tableIds"}>
                            <Select mode={"multiple"} options={tableOptions} placeholder={"请选择可用球台"}></Select>
                        </Form.Item>
                    }}
                />
            }
        </Form>
    </Modal>
}


// WEBPACK FOOTER //
// ./src/containers/ClubCharge/component/ClubChargeForm.js